<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
    :footer="false"
  >
    <form class="t-walkthrough-select-business-hours__form" @submit.prevent="handleSubmitForm">
      <div class="t-walkthrough-select-business-hours__description">
        <a-heading tag="h3" size="small">営業時間の設定を行いますか？</a-heading>
        <a-text>
          設定する場合、続けて2つの設定を行います<br />
          1. 営業時間の設定<br />
          2. 対応方法、ガイダンスの設定
        </a-text>
      </div>
      <div class="t-walkthrough-select-business-hours__fields">
        <a-radio v-model="enabled" name="enabled-business-hour" variant="button" value="1" label="設定する" />
        <a-radio v-model="enabled" name="enabled-business-hour" variant="button" value="0" label="設定しない" />
      </div>
      <div class="t-walkthrough-select-business-hours__instruction">
        <a-alert title="COTOHA Call Centerの営業時間設定">
          <a-text>
            営業時間を設定すると、その時間を目安に、営業時間外対応のオンオフを自動で切り替えます。対応は①ガイダンスを流して切断
            ②外線に転送から選択できます。<br />
            <br />
            （例）営業時間を9:00-12:00 / 13:00-17:00と設定した場合
          </a-text>
          <figure class="t-walkthrough-select-business-hours__instruction-image">
            <img src="@/images/walkthrough/select-business-hours.svg" />
          </figure>
        </a-alert>
      </div>
      <div class="t-walkthrough-select-business-hours__buttons">
        <m-button-container>
          <a-button variant="block" submit="submit" color="primary">次へ</a-button>
          <a-button variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
          <a-button
            color="primary"
            class="t-walkthrough-select-business-hours__button-optional"
            @click="handleNotSettingClick"
            >初期設定はせずにホーム画面へ</a-button
          >
        </m-button-container>
      </div>
    </form>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import AAlert from '@/components/atoms/alert';
import AHeading from '@/components/atoms/heading';
import ARadio from '@/components/atoms/radio';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MButtonContainer from '@/components/molecules/button-container';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 't-walkthrough-select-business-hours',
  components: {
    TDefaultEntrySidebar,
    AAlert,
    AHeading,
    ARadio,
    AButton,
    AText,
    MButtonContainer,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // handleFormSubmit: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleNotSettingClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      enabled: '1',
      sidebarInfo: {
        sidebarList: [{ label: 'ユーザー招待' }, { label: '営業時間設定' }, { label: '着信フローの設定' }],
        sidebarCurrent: 2,
        heading: '営業時間設定',
        subHeading: 'Step 2',
        sidebarSubHeading: 'Walk Through',
        sidebarHeading: '初期設定',
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-walkthrough-select-business-hours');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleSubmitForm(e) {
      e.preventDefault();
      this.handleFormSubmit(this.enabled === '1');
    },
    handleFormSubmit(isSetting) {
      //console.log('営業時間設定');
      if (isSetting) {
        this.$router.push({ name: 'WTBusinessHoursDateTime' });
      } else {
        this.$router.push({ name: 'WTSelectIvr' });
      }
    },
    handleCancelClick() {
      this.$router.push({ name: 'WTInviteUser' });
    },
    handleNotSettingClick() {
      this.updateFirstVisitFlag();
      this.$router.push({ name: 'Home' });
    },
    updateFirstVisitFlag(status = false) {
      this.postRequest('/walkthrough/update-firstVisitFlag', { status })
        .then(res => {
          if (res.status === 'success') {
            //console.log('firstVisitFlag is updated to', status);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
  },
};
</script>
